export default "__VITE_ASSET__Jr4u9RYD__"